var map = {
	"./config.js": "47GS",
	"./keepAlive.js": "7T/y",
	"./route.js": "HXzR",
	"./socket.js": "WI9n",
	"./token.js": "PL7o",
	"./ws.js": "95m8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6yS2";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive .js$
// module id = 6yS2
// module chunks = 73